var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resource"},[_c('content-header'),_vm._v(" "),_c('div',{staticClass:"iframe-cont"},[_c('iframe',{staticClass:"mt--200 resource__iframe",class:{ largeIframe: _vm.fullIframe },style:({
                width:
                    _vm.content.settings.width !== '100%'
                        ? _vm.content.settings.width + 'px'
                        : _vm.content.settings.width
            }),attrs:{"src":_vm.content.url,"width":_vm.content.settings.width,"height":_vm.content.settings.height}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }